import React from 'react';
import Button from '@mui/material/Button';
import BoardImage from '@/assets/images/lifecycle-board.svg';
import BasicPageLayout from '@/components/common/BasicPageLayout';
import { useCurrentUser } from '@/lib/hooks/userData';
import translate from '@/lib/intl/translate';
import { Dialogs, useDialogManager } from '@/modules/Dialogs';

function EmptyListView() {
  const { isOrgAdmin } = useCurrentUser(true);
  const { closeDialog, openDialog } = useDialogManager();

  return (
    <BasicPageLayout>
      <div className="flex w-full flex-col p-3 pb-32 md:p-4">
        <header className="mb-4 flex items-center">
          <h1 className="text-2xl font-semibold">
            {translate('LIFECYCLE_BOARDS')}
          </h1>
        </header>
        <div className="mt-12 flex flex-grow flex-col items-center">
          <img src={BoardImage} className="mx-auto my-3" alt="" />
          <p className="type-body2">{translate('BOARD_EMPTY_LIST')}</p>
          {isOrgAdmin && (
            <Button
              className="mt-4"
              color="primary"
              variant="contained"
              onClick={() =>
                openDialog(Dialogs.CREATE_LIFECYCLE_BOARD, {
                  onClose: closeDialog,
                })
              }
            >
              {translate('BOARD_CREATE_NEW')}
            </Button>
          )}
        </div>
      </div>
    </BasicPageLayout>
  );
}

export default EmptyListView;
